import React from 'react';
import { SignUp } from '@clerk/clerk-react';

export const Signup: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-800 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white mb-2">Table Footy</h1>
          <p className="text-gray-300">Create your account</p>
        </div>
        <SignUp
          routing="path"
          path="/signup"
          signInUrl="/login"
          afterSignUpUrl="/"
        />
      </div>
    </div>
  );
};
